// extracted by mini-css-extract-plugin
export default {"container":"Mp-z","heading":"Np-z","text":"Op-z","info":"Pp-z","link":"Qp-z","fullMaxWidth":"Rp-z"};